import React, {useLayoutEffect, useRef} from 'react';
import styles from './styles';

const TriageDropdown = (props) => {

  const [hoverRow, setHoverRow] = React.useState(false)

  const handleRoute = (id, instance) => {
    console.log(props, id, instance, "PROPS")
    const win = window.open(`/${instance}/user/overview/${id}`, "_blank");
    win.focus();
  }

  const elemRef = useRef();
  useLayoutEffect(() => {
    if (elemRef.current) {
      props.measureCallback(elemRef.current)
    }
  }, [props.data])

  const theadStyles = {...styles.triageDropdowns.thead, ...styles.triageDropdowns.col}

  return <div style={{backgroundColor: 'white', padding: 5, borderBottom: '1px solid rgb(218, 233, 247)'}} ref={elemRef}>
    <table style={styles.triageDropdowns.table}>
      <tr style={styles.triageDropdowns.head}>
        <th style={theadStyles}/>
        <th style={theadStyles}>Name</th>
        <th style={theadStyles}>Phone</th>
        <th style={theadStyles}>Email</th>
        <th style={theadStyles}>MRN</th>
        {/*<th style={theadStyles}>Source</th>*/}
      </tr>
      {(props.data && props.data.registries) && props.data.registries.map((registry, index) => {
        let isOdd = (index+1)%2
        let rowStyles = styles.triageDropdowns.row;
        if(isOdd) rowStyles = {...rowStyles, background: '#f4faff'}
        if(hoverRow === index) rowStyles = {...rowStyles, background: '#e5f4ff'}
        return <tr
          key={index}
          style={rowStyles}
          onClick={() => handleRoute(registry.id, registry.instance)}
          onMouseEnter={() => setHoverRow(index)}
          onMouseLeave={() => setHoverRow(false)}
        >
          <td style={styles.triageDropdowns.col}>{index+1}</td>
          <td style={styles.triageDropdowns.col}>{registry.name}</td>
          <td style={styles.triageDropdowns.col}>{registry.phone}</td>
          <td style={styles.triageDropdowns.col}>{registry.email}</td>
          <td style={styles.triageDropdowns.col}>{registry.mrn}</td>
          {/*<td style={styles.triageDropdowns.col}>{registry.platform}</td>*/}
        </tr>
      })}
    </table>
  </div>
}

export default TriageDropdown;
